import { defineElement } from "domvm";
import { Component } from "./Component.js";
import { isFlagEnabled, resolveValue } from "./utils/ui-helpers.js";

export class Module extends Component {


    constructor(app, options = {}) {

        super(app, options);

        const {
            moduleName = 'Module',
            moduleTitle = () => 'Module',
            moduleStateSlotName = null,
            moduleMode = Module.MODE_MODULE,
            ignoreModuleState = false,
        } = options;

        this.moduleName = moduleName;
        this.moduleTitle = moduleTitle;
        this.moduleStateSlotName = moduleStateSlotName ?? (() => `${this.getModuleName()}State`);
        this.moduleMode = moduleMode;
        this.ignoreModuleState = ignoreModuleState === true;

    };

    static MODE_MODULE = 'module';
    static MODE_CONTROL = 'control';

    // --------------------------------------------------------------------------------------------

    handleError(error) {

        this.getApp().handleError(error);

    };

    // --------------------------------------------------------------------------------------------

    getModuleName() { return resolveValue(this.moduleName, this); }

    getModuleTitle() { return resolveValue(this.moduleTitle, this); }

    getModuleMode() { return this.moduleMode; }

    getModuleStateSlotName() { return resolveValue(this.moduleStateSlotName, this); }

    getLogger() { return this.getApp().getLogger(); }

    shouldIgnoreModuleState(options = null) {

        if (isFlagEnabled(options, 'ignoreModuleState'))
            return true;

        return this.ignoreModuleState === true;

    }

    shouldResetModuleState(options = null) {

        if (isFlagEnabled(options, 'resetModuleState'))
            return true;

        return false;

    }

    getModuleState() { return {}; }

    setModuleState(state) {

        if (!state)
            return;

    };

    storeModuleState(options = null) {

        if (this.shouldIgnoreModuleState(options))
            return null;

        const storage = this.getApp().getStorage();
        const state = this.getModuleState();
        storage.setModuleState(this.getModuleStateSlotName(), state);
        return state;

    };

    resetModuleState() {

        const storage = this.getApp().getStorage();
        storage.resetModuleState(this.getModuleStateSlotName());

    };

    restoreModuleState(options = null) {

        if (this.shouldIgnoreModuleState(options))
            return;

        const storage = this.getApp().getStorage();
        const state = storage.getModuleState(this.getModuleStateSlotName());
        this.setModuleState(state);

    };

    // --------------------------------------------------------------------------------------------

    async prepare(options, activeRoute) {

        activeRoute = activeRoute || this.getApp().getActiveRoute();
        await this._prepare(options, activeRoute);
        await Promise.all(this.getControls().map(control => control.prepare(options, activeRoute)));

    };

    async _prepare(options, activeRoute) {

        const storage = this.getApp().getStorage();
        storage.createModuleStateSlot(this.getModuleStateSlotName());
        if (this.shouldResetModuleState(options))
            this.resetModuleState();

        await super._prepare(options);

    }

    async refresh(options, activeRoute) {

        activeRoute = activeRoute || this.getApp().getActiveRoute();
        await this._refresh(options, activeRoute);
        await Promise.all(this.getControls().map(control => control.refresh(options, activeRoute)));

    };

    async _refresh(options, activeRoute) {

        if (this.shouldResetModuleState(options))
            this.resetModuleState();

        this.restoreModuleState(options);
        await super._refresh(options, activeRoute);

    };

    // --------------------------------------------------------------------------------------------

    _render(vm, module) {

        const el = defineElement;

        return el('div', [
            '[Module]'
        ]);

    };


}
